export enum HoldMusicType {
  Default = 0,
  Custom = 1,
}
